import React from 'react';
import AdminWrapper from '../components/layout/AdminWrapper';
import AddEventForm from '../components/forms/AddEventForm';

const AdminAddEvent = () => (
  <AdminWrapper>
    <AddEventForm isEditMode={false} />
  </AdminWrapper>
);

export default AdminAddEvent;
